{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Pełny ekran",
		"achievements": "Osiągnięcia",
		"reset": "Reset",
		"language": "Język"
	},
	"achievements": {
		"title": "Osiągnięcia",
		"noAchievements": "Brak osiągnięć. Klikaj dalej!",
		"unlocked": "Odblokowano osiągnięcie: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Królik Początkujący",
		"carrotSnatcher": "🥕 Złodziej Warzyw",
		"bunnyBerserker": "😡 Wściekły Królik",
		"hopPunk": "🎸 Królik Anarchista",
		"bunnyNinja": "🥷 Cichy ale Śmiertelny",
		"expert": "🌟 Ekspert Skoków",
		"master": "👑 Król Marchewek",
		"carrotpocalypse": "🥕 Niszczyciel Ogrodów",
		"bunnyOverlord": "😈 Najwyższy Władca Króliczej Nory",
		"chaosHare": "🌪️ Agent Chaosu",
		"carrotCultist": "⛪ Najwyższy Kapłan Kultu Marchewki",
		"bunnyberryPie": "🥧 Mistrz Halucynogennych Ciast",
		"rabbitHole": "🕳️ Kopacz Kwantowych Tuneli",
		"moonRabbit": "🌙 Księżycowy Królik",
		"bunnyDoom": "💀 Zwiastun Króliczej Apokalipsy",
		"carrotNuke": "☢️ Posiadacz Nuklearnej Marchewki",
		"bunnyMatrix": "🤖 Błąd w Króliczym Matriksie",
		"cosmicHare": "🌌 Kosmiczny Zając się Budzi",
		"warrenSingularity": "🕳️ Osobliwość Nory Osiągnięta",
		"eternalBunny": "♾️ Wieczny Królik"
	},
	"messages": {
		"prophecy": "Starożytna przepowiednia klikania zaczyna się spełniać...",
		"cosmic": "Kosmiczni klikacze byliby dumni z twojego postępu!",
		"astral": "Klikanie odbija się echem w astralnej płaszczyźnie...",
		"speaking": "Czekaj... słyszałeś to? Kliknięcia mówią do mnie...",
		"ancient": "Twoje klikanie rezonuje ze starożytną mocą!",
		"sages": "Mędrcy Klikania szepczą o twoim potencjale...",
		"demons": "SPÓJRZ! Demony Klikania budzą się ze snu!",
		"veil": "Twoje kliknięcia przebijają zasłonę rzeczywistości!",
		"spirits": "Duchy Klikania tańczą w twoim rytmie...",
		"council": "Wielka Rada Klikania zauważyła twoje oddanie",
		"primordial": "Twoje klikanie budzi pierwotne siły!",
		"void": "Pustka klikania spogląda na ciebie...",
		"runes": "Starożytne runy klikania świecą twoją mocą!",
		"beast": "TRZY TRZY TRZY - LICZBA BESTII KLIKANIA",
		"prophets": "Prorocy Klikania śpiewają o twoim nadejściu!",
		"dimensions": "Twoje kliknięcia odbijają się echem przez wymiary...",
		"portal": "Twoje kliknięcia otworzyły portal do Wymiaru Klikania!",
		"sacrifice": "Starożytni Bogowie Klikania żądają WIĘCEJ OFIAR",
		"jackpot": "JACKPOT! Kasyno Klikania wita swojego nowego mistrza!",
		"unmatched": "你的点击力量无人能及! (Twoja moc klikania jest niezrównana!)",
		"reality": "Sama rzeczywistość ugina się pod twoją wolą klikania!",
		"elite": "STAŁEŚ SIĘ ELITARNYM MISTRZEM KLIKANIA",
		"power": "Twój poziom mocy klikania przekracza 1500!",
		"devils": "Diabły Klikania kłaniają się twojej potędze",
		"lucky": "Szczęśliwe kliknięcia płyną w twoich żyłach",
		"dynasty": "Dynastia Klikania uznaje twoją supremację",
		"twoThousand": "Dwa tysiące kliknięć czystej mocy!",
		"transcend": "Twoje klikanie przekracza śmiertelne pojmowanie",
		"constellation": "Konstelacja Klikania układa się na twoją cześć",
		"destiny": "TRZY TYSIĄCE KLIKNIĘĆ PRZEZNACZENIA",
		"triforce": "Potrójna Moc Klikania budzi się!",
		"fortune": "Fortuna sprzyja wytrwałym klikaczom",
		"newDimensions": "Twoja moc klikania sięga nowych wymiarów",
		"quartet": "Kwartet Poczwórnego Klikania harmonizuje",
		"threshold": "Stoisz na progu boskości klikania",
		"ultimate": "PIĘĆ TYSIĘCY KLIKNIĘĆ OSTATECZNEJ MOCY!",
		"force": "Pięciopalczasta Siła Klikania jest na twoje rozkazy",
		"underworld": "Podziemny Świat Klikania koronuje cię na władcę",
		"maxJackpot": "OSIĄGNIĘTO MAKSYMALNY JACKPOT KLIKANIA",
		"infinite": "无限点击力量! (NIESKOŃCZONA MOC KLIKANIA!)",
		"godhood": "WZNIOSŁEŚ SIĘ DO RANGI BOGA KLIKANIA",
		"burrow": "Kopałeś głębiej niż jakikolwiek królik przed tobą...",
		"warren": "Wielka Nora rozpoznaje twoją obecność...",
		"thump": "Ziemia drży przy każdym tupnięciu twojej łapki!",
		"darkWarren": "Mroczna Nora otwiera dla ciebie swoje bramy...",
		"ears": "Twoje uszy rosną... teraz słyszysz wszystko...",
		"carrotThrone": "Tron Marchewkowy materializuje się przed tobą...",
		"onesAlignment": "Wszystkie jedynki się wyrównują - Częstotliwość Nory rezonuje!",
		"moonSummon": "Księżycowy Królik słyszy twoje wołanie przez pustkę...",
		"edgeOfForever": "Stoisz na krawędzi wieczności... uszy drgają...",
		"beyondTheVeil": "Za zasłoną, wszystkie nory stają się jedną...",
		"sequence": "1-2-3-4-5... Święta Sekwencja Skoków jest kompletna!",
		"hyperElite": "HIPER ELITARNY STATUS KRÓLIKA ODBLOKOWANY 🐇🐇🐇",
		"eventHorizon": "Za horyzontem zdarzeń Kosmicznej Króliczej Nory...",
		"matrixAwakens": "Matrix Nory glitchuje... widzisz marchewki za rzeczywistością",
		"luckyForever": "Każda łapka, każdy skok, każde drgnięcie... pobłogosławione na wieki",
		"twentyK": "DWADZIEŚCIA TYSIĘCY. Nie jesteś już królikiem. Jesteś TYM królikiem.",
		"singularity": "Królicza Osobliwość. Wszystkie króliki to ty. Ty jesteś wszystkimi królikami.",
		"tripleAscension": "Potrójne Wniebowstąpienie Kosmicznego Zająca!",
		"ultimateAnswer": "42 000 - Ostateczna Odpowiedź to od zawsze były marchewki",
		"eternity": "♾️ WIECZNA NORA NIE MA KOŃCA. TY RÓWNIEŻ NIE. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Punktów Bonusowych!",
		"clickStreak": "🔥 {{count}} Kliknięć pod Rząd!",
		"fire": "🔥 Moc Ognia Aktywowana!"
	},
	"table": {
		"achievement": "Osiągnięcie",
		"progress": "Postęp"
	},
	"reset": {
		"confirm": "Czy na pewno chcesz zresetować cały postęp? Tej operacji nie można cofnąć."
	}
}
